<template>
  <div class="p-16">
    <div class="max-w-5xl mx-auto space-y-16">
      <div class="flex items-center justify-between">
        <h4 class="text-indigo-500">
          {{ $t('global.accounts') | capitalize }}
        </h4>
        <RouterLink
          v-if="$isAdminOrSuperAdmin"
          :to="{ name: 'accounts.create' }"
          class="btn btn-brand px-6"
        >
          {{ $t('newAccount') | capitalize }}
        </RouterLink>
      </div>
      <DataIterat
        :headless="fetching"
        searchable
        :filterable="false"
        :bulk-actionable="false"
        :paginatable="meta && meta.last_page !== 1"
        v-bind="{ items: accounts, loading: fetching, meta }"
        v-on="{ getData: handleGetAccounts }"
      >
        <DataIteratHeaderContent slot="list-header-content" />
        <DataIteratItemContent
          slot="list-item-content"
          slot-scope="{ dataItem }"
          v-bind="{ account: dataItem }"
        />
      </DataIterat>
    </div>
  </div>
</template>

<script>
import DataIteratHeaderContent from '@/components/Accounts/DataIteratHeaderContent.vue';
import DataIteratItemContent from '@/components/Accounts/DataIteratItemContent.vue';
import DataIterat from '@/components/Ui/DataIterat.vue';
import { accountComputed, accountMethods } from '@/store/helper';

export default {
  name: 'AccountList',
  components: {
    DataIterat,
    DataIteratItemContent,
    DataIteratHeaderContent,
  },
  data: () => ({
    fetching: false,
  }),
  computed: {
    ...accountComputed,
  },
  destroyed() {
    this.setIds([]);
    this.setMeta(null);
    this.setLinks(null);
  },
  methods: {
    ...accountMethods,
    handleGetAccounts(queryParams = {}) {
      this.fetching = true;
      this.getAccounts({ queryParams: { ...queryParams, include: 'membershipProduct' } })
        .then(() => {
          this.fetching = false;
        })
        .catch(() => {
          this.fetching = false;
        });
    },
  },
};
</script>
